import { render, staticRenderFns } from "./pay_setting.vue?vue&type=template&id=4e998406&scoped=true&"
import script from "./pay_setting.vue?vue&type=script&lang=ts&"
export * from "./pay_setting.vue?vue&type=script&lang=ts&"
import style0 from "./pay_setting.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./pay_setting.vue?vue&type=style&index=1&id=4e998406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e998406",
  null
  
)

export default component.exports